export default __webpack_public_path__ + "static/media/ante-logo.00c012b0.svg";